import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import DataMap from 'components/DataMap/DataMap';

import { getFarmedCampaignApnsByBounds } from 'utils/api';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  legend: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '14px 18px',
    borderRadius: '8px',
    backgroundColor: theme.palette.offWhite.main,
    color: theme.palette.darkGray.main,
    flexWrap: 'wrap',
  },
  legendTitle: {
    margin: 0,
    fontSize: '14px',
    fontWeight: 700,
    color: theme.palette.black.main,
  },
  legendItem: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    lineHeight: '20px',
  },
  legendDot: {
    width: '10px',
    height: '10px',
    borderRadius: '999px',
  },
  activeDot: {
    backgroundColor: '#F04528',
  },
  pausedDot: {
    backgroundColor: '#9ca3af',
  },
  adminMap: {
    flex: 1,
    minHeight: '700px',
    display: 'flex',
    flexDirection: 'column',
  },
}));

const FarmedApnsDataMapView = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.legend}>
        <p className={classes.legendTitle}>Marker Legend</p>
        <span className={classes.legendItem}>
          <span className={`${classes.legendDot} ${classes.activeDot}`} />
          Active campaigns
        </span>
        <span className={classes.legendItem}>
          <span className={`${classes.legendDot} ${classes.pausedDot}`} />
          Paused campaigns
        </span>
      </div>
      <div className={classes.adminMap}>
        <DataMap
          renderSearchZipcodesForm
          fetchHighlightEventDataByBounds={getFarmedCampaignApnsByBounds}
          enableEventDataDetails
        />
      </div>
    </div>
  );
};

export default FarmedApnsDataMapView;
